import { cast, types } from 'mobx-state-tree';
import { toJS } from 'mobx';
const SelectedItemsModel = types.model({
  propertyAddress: types.string,
  addressId: types.string,
  propertyId: types.string,
  propertyStatus: types.string,
  currentPortfolioId: types.maybeNull(types.string)
});
const PortfoliosMultiActionStore = types.model('PortfoliosMultiActionStore', {
  selectedItems: types.optional(types.array(SelectedItemsModel), [])
}).actions(store => ({
  setSelectedItem(item) {
    try {
      const index = store.selectedItems.findIndex(i => i.propertyId === item.propertyId);
      if (index === -1) {
        store.selectedItems.push(toJS(item));
      }
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  deselectSelectedItem(id) {
    try {
      const index = store.selectedItems.findIndex(i => i.propertyId === id);
      store.selectedItems.splice(index, 1);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  selectAll(items) {
    try {
      store.selectedItems = cast([]);
      items.forEach(i => {
        store.selectedItems.push(toJS(i));
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  deselectAll() {
    try {
      store.selectedItems = cast([]);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
})).views(store => ({
  isSelected(id) {
    return store.selectedItems.findIndex(i => i.propertyId === id) !== -1;
  }
}));
export const portfoliosMultiActionStore = types.optional(PortfoliosMultiActionStore, {});